import { useCarousel } from '@hooks/useCarousel';
import noop from 'lodash/noop';
import * as React from 'react';
const CarouselContext = React.createContext({
    activeIndex: 0,
    goToIndex: noop,
    goToNext: noop,
    goToPrev: noop,
    reinitialise: noop,
    maxIndex: 0,
    offset: 0,
    offsets: [],
    recalculate: noop,
    refContainer: null,
    refTrack: null,
    count: 0,
    paddingOffset: 0,
});
export const useCarouselContext = () => React.useContext(CarouselContext);
const CarouselProvider = ({ children, ...otherProps }) => {
    const carousel = useCarousel(otherProps);
    React.useEffect(() => {
        if (carousel.paddingOffset !== otherProps.paddingOffset ||
            carousel.count !== otherProps.count) {
            carousel.reinitialise(carousel.count, otherProps.paddingOffset);
        }
    }, [otherProps.paddingOffset]);
    return React.createElement(CarouselContext.Provider, { value: carousel }, children);
};
export default CarouselProvider;
